import React, { useEffect, useRef, useState } from "react";
import { Table } from "react-bootstrap";

interface ThresholdRow {
  min: string;
  max: string;
  rate: string;
}

interface ThresholdPayload {
  isInputPage?: 0 | 1;
  min: number;
  max: number;
  rate: number;
}

interface Props {
  isInputPages?: "Input" | "Output";
  value?: ThresholdPayload[];
  onChange: (data: ThresholdPayload[]) => void;
  onValidationError: (errors: string[]) => void;
  isCaseBilling?: boolean;
  isCancel?: boolean;
  disabled?: boolean
}

const BillingTeamsEditableTable: React.FC<Props> = ({
  isInputPages,
  value,
  onChange,
  onValidationError,
  isCaseBilling = false,
  isCancel = false,
  disabled = false,
}) => {
  const [rows, setRows] = useState<ThresholdRow[]>([]);
  const isInitialized = useRef(false);

  useEffect(() => {
    if (!value || value.length === 0) return;
    if (isInitialized.current && !isCancel) return;

    setRows(
      value.map((v) => ({
        min: String(v.min),
        max: String(v.max),
        rate: String(v.rate),
      }))
    );

    isInitialized.current = true;
  }, [value]);

  const handleRateChange = (index: number, val: string) => {
    const regex = /^[0-9]*\.?[0-9]*$/;
    if (!regex.test(val)) return;

    const updated = [...rows];
    updated[index].rate = val;
    setRows(updated);

    const payload: ThresholdPayload[] = updated.map((r) => ({
       ...(isInputPages && {
        isInputPage: isInputPages === "Input" ? 1 : 0,
      }),
      min: Number(r.min),
      max: Number(r.max),
      rate: Number(r.rate),
    }));

    onChange(payload); 
    onValidationError([]);
  };

  return (
    <div className="table-responsive border-0 mb-2">
      <Table>
        <thead>
          <tr>
            {["Min", "Max", "Amount"].map((h) => (
              <th
                key={h}
                style={{
                  border: "none",
                  padding: "6px",
                  backgroundColor: "#e0f7fa",
                  width:"33%"
                }}
              >
                {h}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {rows.map((row, index) => (
            <tr key={index}>
              <td>{row.min}</td>
              <td>{row.max}</td>
              <td style={{textAlign:"left"}}>
                 {isCaseBilling ? (
                  <span className="text-left">{row.rate}</span>
                ) : (
                  <input
                    type="text"
                    value={row.rate}
                    onChange={(e) =>
                      handleRateChange(index, e.target.value)
                    }
                    className="form-control threshold-input"
                    disabled={disabled}
                  />
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <style>
        {`
          .threshold-input {
            height: 40px;
            padding: 4px 8px;
            font-size: 13px;
          }
        `}
      </style>
    </div>
  );
};

export default BillingTeamsEditableTable;
